// Homepage. Bare language root (/nl, /en) — one segment, so it is more specific
// than the '/*' SPA catch-all and wins for the language roots. Two-segment
// routes (/nl/products, /nl/cart, ...) do not match this and go to their own
// Vike page or the catch-all.
export default '/@lang'
